import { en } from './en.js';
import { uk } from './uk.js';

export { en, uk };

export const translationResources = { en, uk };

export function flattenTranslationKeys(value: object, prefix = ''): string[] {
  return Object.entries(value).flatMap(([key, nested]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    return typeof nested === 'object' && nested !== null
      ? flattenTranslationKeys(nested, path)
      : [path];
  });
}
